<template>
  <transition name="el-zoom-in-top">
    <!-- <div class="content-wrapper"> -->

    <!-- Main content -->
    <section class="content">
      <el-dialog title="Login" :visible="true" size="tiny">
        <div class="account-box">
          <el-form
            :model="inputs"
            ref="login"
            label-width="120px"
            label-position="top"
            @submit.native.prevent="formSubmit"
          >
            <div class="form-group">
              <!-- <a href="#" class="pull-right label-forgot">Forgot email?</a> -->
              <label for="inputUsernameEmail">Username or email</label>
              <el-input
                type="text"
                id="inputUsernameEmail"
                class="input-shell"
                :class="{error: $v.inputs.email.$error}"
                v-model.trim="inputs.email"
                @input="$v.inputs.email.$touch()"
              ></el-input>
            </div>
            <div class="form-group">
              <!-- <a href="#" class="pull-right label-forgot">Forgot password?</a> -->
              <label for="inputPassword">Password</label>
              <PasswordInput
                :class="{error: $v.inputs.password.$error}"
                class="input-shell"
                autocomplete="current-password"
                v-model="inputs.password"
                @input="$v.inputs.password.$touch()"
              ></PasswordInput>
            </div>
            <div class="form-group has-error">
              <label v-show="!!serverErrors">{{serverErrors}}</label>
            </div>
            <!-- <div class="checkbox pull-left">
              <label>
                <input type="checkbox">Remember me
              </label>
            </div>-->

            <button class="btn btn btn-primary pull-right" type="submit" @click="formSubmit">
              Log In
              <DotsLoading :loading="!!loginPromise"></DotsLoading>
            </button>
          </el-form>
          <a class="forgotLnk" href="#"></a>
        </div>
      </el-dialog>
    </section>
    <!-- /.content -->
    <!-- </div> -->
  </transition>
</template>
<script>
import { authClient } from "@api/auth";
import PasswordInput from "@components/partials/PasswordInput.vue";
import DotsLoading from "@components/partials/DotsLoading.vue";
import { required, email } from "vuelidate/lib/validators";
export default {
  components: {
    PasswordInput,
    DotsLoading
  },
  data() {
    return {
      inputs: {
        email: undefined,
        password: undefined
      },
      loginPromise: undefined,
      serverErrors: ""
    };
  },
  validations: {
    inputs: {
      email: {
        required,
        email: v => (v || "").includes(":as:") || email(v)
      },
      password: {
        required
      }
    }
  },
  mounted() {
    localStorage.removeItem("jwt");
    localStorage.removeItem("user");
  },
  methods: {
    handleClose(done) {
      // this.$confirm(
      //   'This will permanently delete the file. Continue?',
      //   'Warning',
      //   {
      //     confirmButtonText: 'OK',
      //     cancelButtonText: 'Cancel',
      //     type: 'warning'
      //   }
      // )
    },
    async loginAsync(email, password, recaptcha) {
      try {
        return await authClient.login(email, password, recaptcha);
      } catch (error) {
        const { response, message } = error;

        if (response && response.data) {
          this.serverErrors = response.data.error || "";
        } else this.serverErrors = message;
        throw error;
      }
    },
    formSubmit() {
      if (this.loginPromise) return;
      this.loginPromise = this.formSubmitAsync()
        .then(() => (this.loginPromise = undefined))
        .catch(error => {
          this.loginPromise = undefined;
          throw error;
        });
    },
    async formSubmitAsync() {
      this.$v.inputs.$touch();
      // const valid = await this.validateAsync(this.$v.inputs)
      // if (!valid || !this.recaptcha) return
      // const response =
      await this.loginAsync(
        this.inputs.email,
        this.inputs.password,
        this.recaptcha
      );
      this.resetForm();
      this.redirect();
    },
    resetForm() {
      this.inputs.email = undefined;
      this.inputs.password = undefined;
      this.serverErrors = "";

      this.$v.$reset();
    },
    redirect() {
      this.$router.replace(this.to || { name: "dashboard" });
    }
  }
};
</script>



// WEBPACK FOOTER //
// Login.vue?0bde86c2